$(".popup .btn-close").click(function () {
  $(".popup").addClass("visually-hidden");
});

const registerOffcanvas = document.getElementById("register");
if (registerOffcanvas) {
  registerOffcanvas.addEventListener("show.bs.offcanvas", (event) => {
    $("body").addClass("register-visible");
  });
  registerOffcanvas.addEventListener("hide.bs.offcanvas", (event) => {
    $("body").removeClass("register-visible");
  });
}

const loginOffcanvas = document.getElementById("login");
if (loginOffcanvas) {
  loginOffcanvas.addEventListener("show.bs.offcanvas", (event) => {
    $("body").addClass("login-visible");
  });
  loginOffcanvas.addEventListener("hide.bs.offcanvas", (event) => {
    $("body").removeClass("login-visible");
  });
}

  var $bagOffcanvas = $("#cart");
  var $cartLink = $(".cart.nav-link");
  var $bagOffCWcanvas = $("#cwCart");
  var cartOffCWcanvas = new bootstrap.Offcanvas($bagOffCWcanvas[0]);
  var cartOffcanvas = new bootstrap.Offcanvas($bagOffcanvas[0]);
  if ($cartLink.length && $bagOffcanvas.length) {
  $cartLink.on("click", function (e) {
    e.preventDefault();
    // Close the phone menu first, otherwise the cart opens underneath it
    var navMenu = document.getElementById("offcanvasNavbar");
    if (navMenu && navMenu.classList.contains("show")) {
      bootstrap.Offcanvas.getOrCreateInstance(navMenu).hide();
    }
    if (window.cwCart) {
      cartOffCWcanvas.show();
      if($("body.a-b-test-collider-8 #cwCart.offcanvas .recommended-products .recommended-products__items .recommended-product").length > 0)
      {
        var $carousel = $("body.a-b-test-collider-8 #cwCart.offcanvas .recommended-products .recommended-products__items");
        if ($carousel.hasClass("slick-initialized")) 
        {
          $carousel.slick("unslick");
        }
        setTimeout(function () {
          $carousel.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            dots: false,
            arrows: true,
          });
        },200);
      }
    }
    else {
      cartOffcanvas.show();
    }
  });
  $bagOffcanvas.on("show.bs.offcanvas", function () {
    if (window.cwCart) {
      // $("body").addClass("bag-visible cw-bag-visible");
    } else {
      $("body").addClass("bag-visible");
    }
  });

  $bagOffcanvas.on("hide.bs.offcanvas", function () {
    if (window.cwCart) {
      $("body").removeClass("bag-visible cw-bag-visible");
    } else {
      $("body").removeClass("bag-visible");
    }
  });
}

$(".select").select2({
  minimumResultsForSearch: Infinity,
});
$(".dropdown-select").select2({
  minimumResultsForSearch: Infinity,
  dropdownCssClass: "subscribe-dropdown",
});

if ($("[data-splitting]").length > 0) {
  Splitting();

  ScrollOut({
    targets: "[data-splitting]",
    offsetY: 100,
  });
}

$(function () {
  var $logoWrappers = $(".scroll-text .colider-logo");

  if ($logoWrappers.length > 0) {
    var startScroll = $(window).scrollTop();
    var offsetEnd = 67; 

    $logoWrappers.each(function () {
      var $el = $(this);
      var logoTop = $el.offset().top; 

      var rawDistance = logoTop - startScroll;    
      var animDistance = rawDistance - offsetEnd;   

      if (animDistance <= 0) {
        animDistance = 1; 
      }

      $el.data("scrollStart", startScroll);
      $el.data("scrollDistance", animDistance);
    });

    function updateLogoScale() {
      var currentScroll = $(window).scrollTop();

      $logoWrappers.each(function () {
        var $el = $(this);
        var start = $el.data("scrollStart");
        var distance = $el.data("scrollDistance");

        var progress = (currentScroll - start) / distance;

        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        this.style.setProperty("--logo-scroll", progress);
      });
    }

    updateLogoScale();
    $(window).on("scroll", updateLogoScale);
  }
});

if ($(".mouse-move").length > 0) {
  var rect = $(".mouse-move")[0].getBoundingClientRect();
  var mouse = { x: 0, y: 0, moved: false };

  $(".mouse-move").mousemove(function (e) {
    mouse.moved = true;
    mouse.x = e.clientX - rect.left;
    mouse.y = e.clientY - rect.top;
  });

  // Ticker event will be called on every frame
  TweenLite.ticker.addEventListener("tick", function () {
    if (mouse.moved) {
      parallaxIt(".box", -100);
    }
    mouse.moved = false;
  });

  function parallaxIt(target, movement) {
    TweenMax.to(target, 0.5, {
      x: ((mouse.x - rect.width / 2) / rect.width) * movement,
      y: ((mouse.y - rect.height / 2) / rect.height) * movement,
    });
  }

  $(window).on("resize scroll", function () {
    rect = $(".mouse-move")[0].getBoundingClientRect();
  });
}

// A touchable lightbox - product page
if ($(".glightbox").length > 0) {
  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });
}

// Discover (Beer)
if ($("#image").length > 0) {
  gsap.registerPlugin(ScrollTrigger);

  const tl = gsap.timeline({
    ease: "none",
  });

  tl.from("#image img", {
    scaleY: 0.21,
    scaleX: 0.122,
    duration: 1,
    transformOrigin: "top center",
  }).to(
    {},
    {
      duration: 1,
    }
  );
  ScrollTrigger.create({
    trigger: "#image",
    start: "top bottom",
    end: "+=200%",
    pin: false,
    animation: tl,
    scrub: 0.38,
    pinSpacing: false,
  });
}

if ($("#image-mobile").length > 0) {
  gsap.registerPlugin(ScrollTrigger);

  const tl = gsap.timeline({
    ease: "none",
  });

  tl.from("#image-mobile img", {
    scaleY: 0.15,
    scaleX: 0.3,
    duration: 1,
    transformOrigin: "top center",
  }).to(
    {},
    {
      duration: 1,
    }
  );
  ScrollTrigger.create({
    trigger: "#image-mobile",
    start: "top bottom",
    end: "+=200%",
    pin: false,
    animation: tl,
    scrub: 0.38,
    pinSpacing: false,
  });
}

/* Style tiles follow the chosen pack size: each tile carries one link per pack size */
$("body").on("updateVariantInfo", function () {
  var pack = String($("#variant-" + $("#product-object").data("variant")).data("option-name") || "");
  if (!pack) return;
  $(".variant-items a[data-pack-urls]").each(function () {
    var urls = {};
    String($(this).data("pack-urls")).split(",").forEach(function (pair) {
      var parts = pair.split("|");
      if (parts.length === 2) urls[parts[0]] = parts[1];
    });
    if (urls[pack]) $(this).attr("href", urls[pack]);
  });
});

/* Videos marked data-lazy-video (showcase) load and play just before they scroll into view */
(function () {
  var videos = document.querySelectorAll("video[data-lazy-video]");
  if (!videos.length) return;
  function start(video) {
    video.querySelectorAll("source[data-src]").forEach(function (source) {
      source.src = source.getAttribute("data-src");
      source.removeAttribute("data-src");
    });
    video.muted = true;
    video.load();
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }
  if (!("IntersectionObserver" in window)) {
    videos.forEach(start);
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        start(entry.target);
      }
    });
  }, { rootMargin: "300px 0px" });
  videos.forEach(function (video) { observer.observe(video); });
})();

/* Product-card hover videos are only fetched when a mouse hovers the card (never on touch screens) */
document.addEventListener("mouseover", function (event) {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  var card = event.target.closest && event.target.closest(".product-item");
  if (!card) return;
  card.querySelectorAll("video[data-hover-video]").forEach(function (video) {
    if (video.getAttribute("data-hover-loaded")) return;
    video.setAttribute("data-hover-loaded", "1");
    video.querySelectorAll("source[data-src]").forEach(function (source) {
      source.src = source.getAttribute("data-src");
    });
    video.muted = true;
    video.load();
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  });
});
